import { Chat } from '@magic/ui/chat';

import { useChat } from '../context/chat';
import { Feedback } from './feedback';

export const Messages = () => {
  const { messages = [], isLoading = false } = useChat();
  return (
    <Chat.Container>
      {isLoading && <Chat.Typing />}
      {messages.map((message) => (
        <Chat.Message
          key={message.id || `${message.role}_${message.createdAt}`}
          message={message}
          footer={
            message.metadata?.welcome ? null : <Feedback message={message} />
          }
        />
      ))}
    </Chat.Container>
  );
};
